import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslationsService } from './service/translations.service';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { TranslationsEffects } from './effects/translations.effects';
import * as TransaltionsStore from './reducers/translations.reducer';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(TransaltionsStore.translationsStoreFeature),
    EffectsModule.forFeature([TranslationsEffects]),
  ],
  providers: [TranslationsService],
})
export class TransaltionsStoreModule {}
